module.exports = __webpack_public_path__ + "static/img/Mitch-McGovern.f38c50c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mitch-McGovern.jpg
// module id = 1EGP
// module chunks = 0